export const socialMediaQueryKey = "socialMediaQueryKey";

export const socialMediaWebsiteQueryKey = "socialMediaWebsiteQueryKey";
